document.addEventListener('turbolinks:load', () => {
  const $ = (window as any).jQuery;

  $('.coupon-curly').each((i: number, element: Element) => {
    $(element).on('click', (event: MouseEvent) => {
      event.preventDefault();
      const $target = $(event.currentTarget);
      $target.css('cursor', 'default');
      $target.find('.coupon-curly__seal, .coupon-curly__corner').remove();
    });
  });

});
